import {NavigationGuardNext, RouteLocationNormalized} from 'vue-router';
import {useAuthStore} from '@/stores/auth';
import {storage} from '@/utils/reactiveStorage';

/**
 * Navigation guard to protect routes that require authentication.
 *
 * @param {RouteLocationNormalized} to - The target route object being navigated to.
 * @param {RouteLocationNormalized} from - The current route being navigated away from.
 * @param {NavigationGuardNext} next - The function to call to resolve the hook.
 */
export function authGuard(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
): void {
    const authStore = useAuthStore();

    // Initialize authentication state if not already done
    if (!authStore.isLoggedIn) {
        authStore.initializeAuth();
    }

    // If the route requires authentication and the user is not logged in, redirect to login
    if (to.meta.requiresAuth && !authStore.isLoggedIn) {
        storage.set('authRedirectPath', to.fullPath);

        authStore.redirectToLogin();
        return;
    }

    // Proceed to the next route
    next();
}